import React from 'react';
import trainingCenterBanner from '../assets_new/training-center.jpg';
import { CoverBanner } from '../Common/CoverItem';
import { Typography } from "@mui/material";
import { makeStyles } from '@mui/styles';
import FadeIn from 'react-fade-in';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import baseStyles from '../Common/styles';

const useStyles = makeStyles((theme) => ({
    ...baseStyles(theme),
    banner: {
        height: '200px',
        overflow: 'hidden'
    },
    videoGallery: {
        display: 'flex',
        justifyContent: 'center',
        padding: '20px 0',
    },
    video: {
        display: 'block',
        width: '100%',
        maxWidth: '720px',
        height: 'auto',
        aspectRatio: '4/3',
        borderRadius: '4px',
    },
    videoContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        maxWidth: '720px',
        margin: '0 auto',
        textAlign: 'center',
    },
    contact: {
        margin: 'auto',
        textAlign: 'center'
    }
}));

export default function TrainingCenter() {
    const classes = useStyles();

    return (
        <FadeIn>
            <div className={classes.root}>
                <div className={classes.banner}>
                    <CoverBanner image={trainingCenterBanner} title='TRAINING CENTER'
                        description={<>
                            <Typography paragraph>Become an expert at using JML's material libraries!</Typography>
                        </>}
                    />
                </div>
                <div className={classes.section}>
                    <Typography variant="header" color="primary">Getting Started</Typography>
                    <Typography paragraph>Learn how to import our digital fabrics into your garment design software</Typography>
                    <div className={classes.videoGallery}>
                        <div className={classes.videoContainer}>
                            <video controls className={classes.video}>
                                <source src="https://jmlapparelstorage.blob.core.windows.net/media/JML_Apparel.mp4" type="video/mp4" />
                            </video>
                            <Typography variant="caption">Browzwear Tutorial</Typography>
                        </div>
                    </div>
                </div>
                <div className={classes.section}>
                    <Typography className={classes.contact} variant="h5" color="primary">Need more help? <Link color="primary" component={RouterLink} to="/contact-us">Contact us </Link></Typography>
                </div>
            </div>
        </FadeIn>
    );
}